import './styles.css'
export const ResourceExpiredPopup = (props) => {
  const { navigate, packageExpire } = props
  return (
    <div className="bg-white text-dark popup-resource-expired">
      <div className="pop-title">
        <span>Thuê bao sắp hết hạn</span>
        {/* <i className="fa fa-exclamation-triangle" aria-hidden="true"></i> */}
      </div>
      <div className="pop-body">
        Thuê bao của Quý khách sẽ hết hạn tài nguyên truyền nhận hóa đơn điện tử{' '}
        <span style={{ color: '#EE2334D9' }}>
          sau {packageExpire?.daysLeft} ngày nữa
        </span>
        . Vui lòng gia hạn thêm tài nguyên để tránh gián đoạn
      </div>
      <div className="pop-actions">
        <button
          className="btn btn-primary"
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            navigate('/hoa-don-dau-ra/he-thong/tai-nguyen')
          }}
        >
          Gia hạn ngay
        </button>
      </div>
    </div>
  )
}
